// Override Settings
var boostPFSFilterConfig = {
  general: {
    limit: 42,
    // Optional
    loadProductFirst: false,
    showPlaceholderProductList: true,
    placeholderProductPerRow: 3,
    placeholderProductGridItemClass:
      "wsg-artwork-card grid__item wide--one-fifth large--one-quarter medium-down--one-half",
  },
  selector: {
    breadcrumb: ".breadcrumb",
  },
};

let filterLabels = Labels;

var counter = 1;

// Filterのタイトル
let optionTitleList = {
  "ARTIST (A-Z)": {
    en: "ARTISTS (A-Z)",
    ja: "アーティスト (A-Z)",
    "zh-TW": "藝術家 (A-Z)",
    "zh-CN": "艺术家 (A-Z)",
    ko: "작가명",
  },
  MEDIUM: {
    en: "MEDIUM",
    ja: "メディウム",
    "zh-TW": "媒材",
    "zh-CN": "媒介",
    ko: "매체",
  },
  SIZE: {
    en: "SIZE",
    ja: "サイズ",
    "zh-TW": "尺寸",
    "zh-CN": "尺寸",
    ko: "크기",
  },
  PRICE: {
    en: "PRICE",
    ja: "価格",
    "zh-TW": "價格",
    "zh-CN": "价格",
    ko: "가격",
  },
  CATEGORIES: {
    en: "CATEGORIES",
    ja: "カテゴリ",
    "zh-TW": "派別種類",
    "zh-CN": "类别",
    ko: "범위",
  },
  "TIME PERIOD": {
    en: "TIME PERIOD",
    ja: "年代",
    "zh-TW": "年代",
    "zh-CN": "年代",
    ko: "시대",
  },
  COLOR: {
    en: "COLOR",
    ja: "カラー",
    "zh-TW": "顏色",
    "zh-CN": "颜色",
    ko: "색상",
  },
  AVAILABILITY: {
    en: "AVAILABILITY",
    ja: "取扱状況",
    "zh-TW": "販售狀態",
    "zh-CN": "销售状态",
    ko: "구매 가능 여부",
  },
};

// Filterの項目
let labelList = {
  Drawing: {
    en: "Drawing",
    ja: "ドローイング",
    "zh-TW": "素描",
    "zh-CN": "素描",
    ko: "드로잉 / 종이작업",
  },
  "Digital Art": {
    en: "Digital Art",
    ja: "デジタルアート",
    "zh-TW": "數字藝術",
    "zh-CN": "数字艺术",
    ko: "디지털 아트",
  },
  "Mixed Media": {
    en: "Mixed Media",
    ja: "ミクストメディア",
    "zh-TW": "複合媒材",
    "zh-CN": "复合媒介",
    ko: "혼합재료",
  },
  Painting: {
    en: "Painting",
    ja: "絵画",
    "zh-TW": "繪畫",
    "zh-CN": "绘画",
    ko: "페인팅 / 원화",
  },
  Print: {
    en: "Print",
    ja: "版画・マルチプル",
    "zh-TW": "版畫",
    "zh-CN": "版画",
    ko: "판화",
  },
  Sculpture: {
    en: "Sculpture",
    ja: "彫刻・立体",
    "zh-TW": "雕刻・立體",
    "zh-CN": "雕刻・立体",
    ko: "조각",
  },
  "Size_Large (Over100cm)": {
    en: "Large (Over100cm)",
    ja: "大 (100cm以上)",
    "zh-TW": "大 (100公分以上)",
    "zh-CN": "大 (100厘米以上)",
    ko: "대형 (100cm 이상)",
  },
  "Size_Medium (40cm-100cm)": {
    en: "Medium (40cm-100cm)",
    ja: "中 (40cm-100cm)",
    "zh-TW": "中 (40-100公分)",
    "zh-CN": "中 (40-100厘米)",
    ko: "중형 (40cm-100cm)",
  },
  "Size_Small (Under40cm)": {
    en: "Small (Under40cm)",
    ja: "小 (40cm以下)",
    "zh-TW": "小 (40公分以下)",
    "zh-CN": "小 (40厘米以下)",
    ko: "소형 (40cm 미만)",
  },
  Categories_GUTAI: {
    en: "GUTAI",
    ja: "GUTAI",
    "zh-TW": "GUTAI",
    "zh-CN": "GUTAI",
    ko: "GUTAI",
  },
  "Categories_POST-WAR": {
    en: "POST-WAR",
    ja: "POST-WAR",
    "zh-TW": "POST-WAR",
    "zh-CN": "POST-WAR",
    ko: "POST-WAR",
  },
  Categories_EMERGING: {
    en: "EMERGING",
    ja: "EMERGING",
    "zh-TW": "EMERGING",
    "zh-CN": "EMERGING",
    ko: "EMERGING",
  },
  Categories_YOUNG: {
    en: "YOUNG",
    ja: "YOUNG",
    "zh-TW": "YOUNG",
    "zh-CN": "YOUNG",
    ko: "YOUNG",
  },
  "Price_$50k+": {
    en: "$50k+",
    ja: "$50k+",
    "zh-TW": "$50k+",
    "zh-CN": "$50k+",
    ko: "$50k+",
  },
  "Price_$25k+-$50k+": {
    en: "$25k+-$50k",
    ja: "$25k+-$50k",
    "zh-TW": "$25k+-$50k",
    "zh-CN": "$25k+-$50k",
    ko: "$25k+-$50k",
  },
  "Price_$10k+-$25k+": {
    en: "$10k+-$25k",
    ja: "$10k+-$25k",
    "zh-TW": "$10k+-$25k",
    "zh-CN": "$10k+-$25k",
    ko: "$10k+-$25k",
  },
  "Price_$5k+-$10k+": {
    en: "$5k+-$10k",
    ja: "$5k+-$10k",
    "zh-TW": "$5k+-$10k",
    "zh-CN": "$5k+-$10k",
    ko: "$5k+-$10k",
  },
  "Price_$1k+-$5k+": {
    en: "$1k+-$5k",
    ja: "$1k+-$5k",
    "zh-TW": "$1k+-$5k",
    "zh-CN": "$1k+-$5k",
    ko: "$1k+-$5k",
  },
  "Price_$0-$1000": {
    en: "$0-$1000",
    ja: "$0-$1000",
    "zh-TW": "$0-$1000",
    "zh-CN": "$0-$1000",
    ko: "$0-$1000",
  },
  TimePeriod_2020: {
    en: "2020s",
    ja: "2020s",
    "zh-TW": "2020年代",
    "zh-CN": "2020年代",
    ko: "2020년대",
  },
  TimePeriod_2010: {
    en: "2010s",
    ja: "2010s",
    "zh-TW": "2010年代",
    "zh-CN": "2010年代",
    ko: "2010년대",
  },
  TimePeriod_2000: {
    en: "2000s",
    ja: "2000s",
    "zh-TW": "2000年代",
    "zh-CN": "2000年代",
    ko: "2000년대",
  },
  TimePeriod_1990: {
    en: "1990s",
    ja: "1990s",
    "zh-TW": "1990年代",
    "zh-CN": "90年代",
    ko: "1990년대",
  },
  TimePeriod_1980: {
    en: "1980s",
    ja: "1980s",
    "zh-TW": "1980年代",
    "zh-CN": "80年代",
    ko: "1980년대",
  },
  TimePeriod_1970: {
    en: "1970s",
    ja: "1970s",
    "zh-TW": "1970年代",
    "zh-CN": "70年代",
    ko: "1970년대",
  },
  TimePeriod_1960: {
    en: "1960s",
    ja: "1960s",
    "zh-TW": "1960年代",
    "zh-CN": "60年代",
    ko: "1960년대",
  },
  TimePeriod_1950: {
    en: "1950s",
    ja: "1950s",
    "zh-TW": "1950年代",
    "zh-CN": "50年代",
    ko: "1950년대",
  },
  Color_BlackAndWhite: {
    en: "Black and White",
    ja: "ブラック/ホワイト",
    "zh-TW": "黑/白",
    "zh-CN": "黑色/白色",
    ko: "검정색 또는 흰색",
  },
  Color_Red: {
    en: "Red",
    ja: "レッド",
    "zh-TW": "紅",
    "zh-CN": "红色",
    ko: "빨강색",
  },
  Color_Yellow: {
    en: "Yellow",
    ja: "イエロー",
    "zh-TW": "黃",
    "zh-CN": "黄色",
    ko: "노랑색",
  },
  Color_Orange: {
    en: "Orange",
    ja: "オレンジ",
    "zh-TW": "橘",
    "zh-CN": "橙色",
    ko: "주황색",
  },
  Color_Pink: {
    en: "Pink",
    ja: "ピンク",
    "zh-TW": "粉紅",
    "zh-CN": "粉红色",
    ko: "분홍색",
  },
  Color_Violet: {
    en: "Violet",
    ja: "バイオレット",
    "zh-TW": "紫",
    "zh-CN": "紫罗兰色",
    ko: "제비꽃",
  },
  Color_Gold: {
    en: "Gold",
    ja: "ゴールド",
    "zh-TW": "金",
    "zh-CN": "金色",
    ko: "금색",
  },
  Color_DarkOrange: {
    en: "Dark Orenge",
    ja: "ダークオレンジ",
    "zh-TW": "暗橘",
    "zh-CN": "深橙色",
    ko: "다크 오렌지",
  },
  Color_DarkGreen: {
    en: "Dark Green",
    ja: "ダークグリーン",
    "zh-TW": "暗綠",
    "zh-CN": "深绿色",
    ko: "짙은 녹색",
  },
  Color_DarkBlue: {
    en: "Dark Blue",
    ja: "ダークブルー",
    "zh-TW": "暗藍",
    "zh-CN": "深蓝色",
    ko: "다크블루",
  },
  Color_DarkViolet: {
    en: "Dark Violet",
    ja: "ダークバイオレット",
    "zh-TW": "暗紫",
    "zh-CN": "深紫罗兰色",
    ko: "다크 바이올렛",
  },
  Color_LightGreen: {
    en: "Light Green",
    ja: "ライトグリーン",
    "zh-TW": "淡綠",
    "zh-CN": "浅绿色",
    ko: "연한 초록색",
  },
  Color_LightBlue: {
    en: "Light Blue",
    ja: "ライトブルー",
    "zh-TW": "淡藍",
    "zh-CN": "浅蓝色",
    ko: "라이트블루",
  },
  Availlability_ForSale: {
    en: "For Sale",
    ja: "販売中",
    "zh-TW": "銷售中",
    "zh-CN": "销售中",
    ko: "구매가능",
  },
  Availlability_Sold: {
    en: "Sold",
    ja: "売約済み",
    "zh-TW": "已完售",
    "zh-CN": "已售出",
    ko: "판매완료",
  },
};
const lang = document.documentElement.lang;

(function () {
  fetch(
    "https://cdn.shopify.com/s/files/1/0550/2356/7044/files/artist.json"
  )
    .then((res) => res.json())
    .then(
      (result) => {
        Object.keys(result).forEach((key) => {
          const keyNum = Number(key);
          const metafield = result[keyNum].metafields;
          const name = result[keyNum].title;

          labelList[name] = {
            en: name,
            ja: "",
            "zh-CN": "",
            "zh-TW": "",
            ko: "",
          };

          Object.keys(metafield).forEach((key) => {
            const objKey = metafield[Number(key)]["key"];
            const objVal = metafield[Number(key)].value;

            if (objKey == "ws_at_title_ja") {
              labelList[name]["ja"] = objVal;
            }
            if (objKey == "ws_at_title_zh-cn") {
              labelList[name]["zh-CN"] = objVal;
            }
            if (objKey == "ws_at_title_zh-tw") {
              labelList[name]["zh-TW"] = objVal;
            }
            if (objKey == "ws_at_title_kr") {
              labelList[name]["ko"] = objVal;
            }
          });
        });
      },
      // 補足：コンポーネント内のバグによる例外を隠蔽しないためにも
      // catch()ブロックの代わりにここでエラーハンドリングすることが重要です
      (error) => {
        console.log(error);
      }
    );
})();

(function () {
  BoostPFS.inject(this);

  // Build Product Grid Item
  ProductGridItem.prototype.compileTemplate = function (
    data,
    index,
    totalProduct
  ) {
    if (!data) data = this.data;
    if (!index) index = this.index;
    if (!totalProduct) totalProduct = this.totalProduct;
    /*** Prepare data ***/
    var images = data.images_info;
    // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data["variants"][0];
    if (Utils.getParam("variant") !== null && Utils.getParam("variant") != "") {
      var paramVariant = data.variants.filter(function (e) {
        return e.id == Utils.getParam("variant");
      });
      if (typeof paramVariant[0] !== "undefined")
        firstVariant = paramVariant[0];
    } else {
      for (var i = 0; i < data["variants"].length; i++) {
        if (data["variants"][i].available) {
          firstVariant = data["variants"][i];
          break;
        }
      }
    }
    /*** End Prepare data ***/

    if (index == 1) counter = 1;

    // Get Template
    var itemHtml = boostPFSTemplate.productGridItemHtml;

    // Add soldOut class
    var itemSoldOutClass = soldOut ? boostPFSTemplate.soldOutClass : "";
    itemHtml = itemHtml.replace(/{{itemSoldOutClass}}/g, itemSoldOutClass);

    // Add soldOut text
    var itemSoldOutText = soldOut ? boostPFSTemplate.soldOutText : "";
    itemHtml = itemHtml.replace(/{{itemSoldOutText}}/g, itemSoldOutText);

    // Add onSale class
    var itemSaleClass = onSale ? boostPFSTemplate.saleClass : "";
    itemHtml = itemHtml.replace(/{{itemSaleClass}}/g, itemSaleClass);

    var textCenterClass = boostPFSConfig.custom.center_grid_link
      ? boostPFSTemplate.textCenterClass
      : "";
    itemHtml = itemHtml.replace(/{{textCenterClass}}/g, textCenterClass);

    var imageSoldOutClass = boostPFSConfig.custom.show_sold_out_circle
      ? boostPFSTemplate.imageSoldOutClass
      : "";
    itemHtml = itemHtml.replace(/{{imageSoldOutClass}}/g, imageSoldOutClass);

    // Add onSale label
    var itemSaleLabelHtml = "";
    if (onSale && boostPFSConfig.custom.show_sale_circle) {
      itemSaleLabelHtml = '<span class="badge badge--sale">';
      if (boostPFSConfig.label.sale.length > 7) {
        itemSaleLabelHtml += '<span class="badge__text badge__text--small">';
      } else {
        itemSaleLabelHtml += '<span class="badge__text">';
      }
      itemSaleLabelHtml += boostPFSConfig.label.sale + "</span></span>";
    }
    itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabelHtml);

    // Add soldOut label
    var itemSoldOutLabeHtml = "";
    if (soldOut && boostPFSConfig.custom.show_sold_out_circle) {
      itemSoldOutLabeHtml = '<span class="badge badge--sold-out">';
      if (boostPFSConfig.label.sold_out.length > 9) {
        itemSoldOutLabeHtml += '<span class="badge__text badge__text--small">';
      } else {
        itemSoldOutLabeHtml += '<span class="badge__text">';
      }
      itemSoldOutLabeHtml += boostPFSConfig.label.sold_out + "</span></span>";
    }
    itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabeHtml);

    // Add Image style
    var imageStyle = "";
    var itemImagesHtml = "";
    if (data.title != "") {
      if (images.length > 0) {
        var img_id = "ProductImage-" + images[0]["id"];
        var wrapper_id = "ProductImageWrapper-" + images[0]["id"] + "";

        var width = boostPFSConfig.custom.product_width;
        var height = 480;
        var aspect_ratio = images[0]["width"] / images[0]["height"];

        var max_width = height * aspect_ratio;
        if (images[0]["height"] < height) {
          var max_height = images[0]["height"];
          max_width = images[0]["width"];
        } else {
          var max_height = width / aspect_ratio;
          if (images[0]["width"] < width) {
            var max_height = images[0]["height"];
            max_width = images[0]["width"];
          } else {
            max_width = width;
          }
        }

        imageStyle =
          "<style>" +
          "#" +
          img_id +
          " {" +
          "max-width: " +
          max_width +
          "px;" +
          "max-height: " +
          max_height +
          "px;" +
          "}" +
          "#" +
          wrapper_id +
          " {" +
          "max-width: " +
          max_width +
          "px;" +
          "}" +
          "</style>";

        var img_url = Utils.optimizeImage(images[0]["src"], "{width}x");
        itemImagesHtml +=
          '<div id="' +
          wrapper_id +
          '" class="product__img-wrapper supports-js">';
        itemImagesHtml +=
          '<div style="padding-top:' +
          (1 / aspect_ratio) * 100 +
          '%;">' +
          '<img id="' +
          img_id +
          '" ' +
          'class="product__img lazyload" ' +
          'src="' +
          Utils.optimizeImage(images[0]["src"], "300x300") +
          '" ' +
          'data-src="' +
          img_url +
          '" ' +
          'data-widths="[150, 220, 360, 470, 600, 750, 940, 1080, 1296, 1512, 1728, 2048]" ' +
          'data-aspectratio="' +
          aspect_ratio +
          '" ' +
          'data-sizes="auto" ' +
          'alt="{{itemTitle}}">' +
          "</div>";
        itemImagesHtml += "</div>";
      } else {
        itemImagesHtml +=
          '<img src="' +
          boostPFSConfig.general.no_image_url +
          '" alt="{{itemTitle}}" class="product__img">';
      }
    } else {
      if (counter == 7) counter = 1;
      if (
        boostPFSConfig.custom.hasOwnProperty("placeholder_svg_tag_" + counter)
      ) {
        itemImagesHtml +=
          boostPFSConfig["custom"]["placeholder_svg_tag_" + counter];
      }
      counter++;
    }
    itemHtml = itemHtml.replace(/{{imageStyle}}/g, imageStyle);
    itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

    // Add Vendor
    var itemVendorHtml = boostPFSConfig.custom.vendor_enable
      ? boostPFSTemplate.vendorHtml
      : "";
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    // 小数点以下を削除
    var trimDecimal = (numStr) => {
      if (numStr.indexOf("€") >= 0) {
        return numStr.replace(/\,0+$/, "");
      } else {
        return numStr.replace(/\.0+$/, "");
      }
    };

    // Add Price
    var itemPriceHtml = "";
    if (!soldOut && data.title != "") {
      if (priceVaries) {
        itemPriceHtml += boostPFSConfig.label.from_price.replace(
          /{{ price }}/g,
          trimDecimal(Utils.formatMoney(data.price_min, Globals.moneyFormat))
        );
      } else {
        itemPriceHtml += onSale
          ? '<span class="visually-hidden">' +
            boostPFSConfig.label.sale_price +
            "</span>"
          : '<span class="visually-hidden">' +
            boostPFSConfig.label.regular_price +
            "</span>";
        itemPriceHtml += trimDecimal(
          Utils.formatMoney(data.price_min, Globals.moneyFormat)
        );
      }
      if (onSale) {
        itemPriceHtml +=
          '<span class="visually-hidden">' +
          boostPFSConfig.label.regular_price +
          "</span>";
        itemPriceHtml +=
          '<s class="grid-link__sale_price">' +
          trimDecimal(
            Utils.formatMoney(data.compare_at_price_min, Globals.moneyFormat)
          ) +
          "</s> ";
      }
    } else if (soldOut) {
      itemPriceHtml = itemSoldOutText;
    }
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    //Add grid Class
    itemHtml = itemHtml.replace(
      /{{grid_item_width}}/g,
      boostPFSConfig.custom.grid_item_width
    );

    // Add Reviews
    if (
      typeof Integration === "undefined" ||
      !Integration.hascompileTemplate("reviews")
    ) {
      itemHtml = itemHtml.replace(/{{itemReviews}}/g, "");
    }

    // Add main attribute
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
    itemHtml = itemHtml.replace(/{{itemLank}}/g, data["variants"][0].barcode);
    itemHtml = itemHtml.replace(
      /{{itemUrl}}/g,
      Utils.buildProductItemUrl(data)
    );

    return itemHtml;
  };

  // Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct;
    // Get page info
    var currentPage = parseInt(Globals.queryParams.page);
    var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

    if (totalPage > 1) {
      var paginationHtml = boostPFSTemplate.paginateHtml;

      // Build Previous
      var previousHtml =
        currentPage > 1
          ? boostPFSTemplate.previousActiveHtml
          : boostPFSTemplate.previousDisabledHtml;
      previousHtml = previousHtml.replace(
        /{{itemUrl}}/g,
        Utils.buildToolbarLink("page", currentPage, currentPage - 1)
      );
      paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

      // Build Next
      var nextHtml =
        currentPage < totalPage
          ? boostPFSTemplate.nextActiveHtml
          : boostPFSTemplate.nextDisabledHtml;
      nextHtml = nextHtml.replace(
        /{{itemUrl}}/g,
        Utils.buildToolbarLink("page", currentPage, currentPage + 1)
      );
      paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

      // Create page items array
      var beforeCurrentPageArr = [];
      for (
        var iBefore = currentPage - 1;
        iBefore > currentPage - 3 && iBefore > 0;
        iBefore--
      ) {
        beforeCurrentPageArr.unshift(iBefore);
      }
      if (currentPage - 4 > 0) {
        beforeCurrentPageArr.unshift("...");
      }
      if (currentPage - 4 >= 0) {
        beforeCurrentPageArr.unshift(1);
      }
      beforeCurrentPageArr.push(currentPage);

      var afterCurrentPageArr = [];
      for (
        var iAfter = currentPage + 1;
        iAfter < currentPage + 3 && iAfter <= totalPage;
        iAfter++
      ) {
        afterCurrentPageArr.push(iAfter);
      }
      if (currentPage + 3 < totalPage) {
        afterCurrentPageArr.push("...");
      }
      if (currentPage + 3 <= totalPage) {
        afterCurrentPageArr.push(totalPage);
      }

      // Build page items
      var pageItemsHtml = "";
      var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
      for (var iPage = 0; iPage < pageArr.length; iPage++) {
        if (pageArr[iPage] == "...") {
          pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
        } else {
          pageItemsHtml +=
            pageArr[iPage] == currentPage
              ? boostPFSTemplate.pageItemSelectedHtml
              : boostPFSTemplate.pageItemHtml;
        }
        pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
        pageItemsHtml = pageItemsHtml.replace(
          /{{itemUrl}}/g,
          Utils.buildToolbarLink("page", currentPage, pageArr[iPage])
        );
      }
      paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

      return paginationHtml;
    }

    return "";
  };

  // Build Sorting
  ProductSorting.prototype.compileTemplate = function () {
    var html = "";
    if (boostPFSTemplate.hasOwnProperty("sortingHtml")) {
      jQ(Selector.topSorting).html("");

      var sortingArr = Utils.getSortingList();
      if (sortingArr) {
        // Build content
        var sortingItemsHtml = "";
        for (var k in sortingArr) {
          sortingItemsHtml +=
            '<option value="' + k + '">' + sortingArr[k] + "</option>";
        }
        html = boostPFSTemplate.sortingHtml.replace(
          /{{sortingItems}}/g,
          sortingItemsHtml
        );
      }
    }
    return html;
  };

  // Build Breadcrumb
  Breadcrumb.prototype.compileTemplate = function (colData) {
    if (!colData) colData = this.collectionData;
    var breadcrumbHtml = "";
    if (
      typeof colData !== "undefined" &&
      colData.hasOwnProperty("collection")
    ) {
      var colInfo = colData.collection;
      breadcrumbHtml =
        '<a href="/" title="' +
        boostPFSConfig.label.breadcrumb_home_link +
        '">' +
        boostPFSConfig.label.breadcrumb_home_link +
        "</a>";
      breadcrumbHtml +=
        ' <span aria-hidden="true" class="breadcrumb__sep">&rsaquo;</span>';
      if (boostPFSConfig.general.current_tags !== null) {
        var currentTags = boostPFSConfig.general.current_tags;
        breadcrumbHtml +=
          ' <a href="/collections/' +
          colInfo.handle +
          '">' +
          colInfo.title +
          "</a>";
        breadcrumbHtml +=
          ' <span aria-hidden="true" class="breadcrumb__sep">&rsaquo;</span>';
        breadcrumbHtml += " <span>" + currentTags.join(" + ") + "</span>";
      } else {
        breadcrumbHtml += " <span>" + colInfo.title + "</span>";
      }
    }
    return breadcrumbHtml;
  };

  // Add additional feature for product list, used commonly in customizing product list
  ProductList.prototype.afterRender = function (data) {
    if (!data) data = this.data;

    // customized by THE GUILD
    // イベントを発火して、商品一覧の価格をAPIから取得・表示する
    document.body.dispatchEvent(new Event("ProductListRendered"));
  };

  // Build additional elements after everything is rendered
  FilterResult.prototype.afterRender = function (data) {
    if (!data) data = this.data;

    // recall EqualHeight from theme.js
    var productGridImages = jQuery(".grid-link__image--product");
    if (productGridImages.length && typeof theme.equalHeights === "function") {
      theme.equalHeights(productGridImages);
    }
  };

  FilterApi.beforeCall = function () {
    if (boostPFSAppConfig.general.collection_handle === "all") {
      FilterApi.setParam("tag", "boost-not-goods");
    }
  };

  ////////////////////////////////
  // 翻訳のための追記（THE GUILD）///
  ////////////////////////////////
  FilterOptionItemList.prototype.buildLabel = function (event) {
    // https://help.boostcommerce.net/article/705-filter-option-item-component#new3
    // https://boost-pfs-lib-v2-dev-doc.s3.us-west-2.amazonaws.com/FilterOptionItemList.html
    // returnした文字列にラベルを書き換える関数
    // Filterの項目を翻訳する
    // Call the original function first

    const defaultLabel = this.label;

    let label = labelList[defaultLabel];
    if (label) {
      return label[lang] ? label[lang] : label.en;
    } else {
      const prefix = this.parent.prefix;
      label = prefix ? defaultLabel.replace(prefix, "") : defaultLabel;
      return label;
    }
  };

  FilterOptionList.prototype.modifyValues = function (values) {
    // https://boost-pfs-lib-v2-dev-doc.s3.us-west-2.amazonaws.com/FilterOptionList.html
    // Filterのタイトルを翻訳する
    let label = optionTitleList[this.label.toUpperCase()];

    if (label) {
      this.label = label[lang] ? label[lang] : label.en;
    }
  };

  // 項目ごとのFilterのresetボタンのlabel
  FilterClearButton.prototype.beforeRender = function (values) {
    let label = {
      en: "Clear",
      ja: "クリア",
      "zh-TW": "清除搜尋條件",
      "zh-CN": "清除搜索条件",
      ko: "Clear",
    };

    this.label = label[lang];
  };

  // SPのREFINE BYボタン
  FilterMobileButton.prototype.beforeRender = function (values) {
    let label = {
      en: "Refine by",
      ja: "検索条件",
      "zh-TW": "搜尋條件",
      "zh-CN": "搜索条件",
      ko: "필터",
    };

    this.label = label[lang];
  };

  // PCとSPのRefine Byの見出し
  FilterRefineBy.prototype.beforeRender = function (val) {
    let label = {
      en: "Refine by",
      ja: "検索条件",
      "zh-TW": "搜尋條件",
      "zh-CN": "搜索条件",
      ko: "필터",
    };

    filterLabels.refine = label[lang];
    filterLabels.refineMobile = label[lang];
  };
})();
